export default "__VITE_ASSET__g5t0nPd4__"